import React, { useEffect, useState } from 'react';
import { useSpearPartsApi } from '../../../../store/api/hooks/spearPartsApiHook';
import { PAGE_SIZE } from '../../../../_common/constant';
import { showDate } from '../../../../_common/functions';
import { AgGridReact } from 'ag-grid-react';
import Search from '../../../../components/search';
import Pagination from '../../../../components/pagination';
import Button from '../../../../components/elements/button';
import Drawer from '../../../../components/Drawer';
import CreateStockAdjustment from '../../StockAdjustment/_components/createStockadjustment';


interface genProps {
	partDetails: any;
}
const StockAdjustmentHistory: React.FC<genProps> = ({ partDetails }) => {
	const spearPartsAPI = useSpearPartsApi();
	const [gridApi, setGridApi] = useState<any>(null);
	const [gridColumnApi, setGridColumnApi] = useState<any>(null);
	const [totalRecords, setTotalRecords] = useState<number>(0);
	const [currentPage, setCurrentPage] = useState<number>(1);
	const [searchParam, setSearchParam] = useState<string>('');

	const [rowData, setRowData] = useState<any>(null)
const stockRef: any = React.createRef<HTMLButtonElement>();
const addNewAdjustmentRef: any = React.createRef<HTMLButtonElement>();
	const onGridReady = (params: any) => {
		setGridApi(params.api);
		setGridColumnApi(params.columnApi);
	};
	const onRowClicked = (event: any) => {
		if (!event.event.target.closest('input[type="checkbox"]')) {
			event.node.setSelected(false); // Unselect row if it's clicked, not by checkbox
		}
	};
	const getSpearPartsList = () => {
		spearPartsAPI.stockAdjustmentHistory({
			partsID: partDetails.partsID,
			pageSize: PAGE_SIZE,
			pageNumber: currentPage,
			searchParam: searchParam,
		}, (data: any) => {
			setTotalRecords(data.totalRecord);
			setRowData(data.stockAdjustmentList ? data.stockAdjustmentList : []);
		}, (error: any) => {
			setRowData([]);
		});
	};

	useEffect(() => {
		getSpearPartsList();
	}, [currentPage, searchParam]);

	const columnDefs = [
		{ headerName: 'Adjustment No', field: 'stockAdjustmentSerialNo', headerClass: 'bg-[#f0f0f0]' },
		{
			headerName: 'Adjustment Qnt', field: 'adjustedQuantity', headerClass: 'bg-[#f0f0f0]',
			cellRenderer: (data: any) => {
				const adjustedQuantity = data.data?.adjustedQuantity || '--';
				const unitName = data.data?.unitName || '';
				return `${adjustedQuantity} ${unitName}`;
			}
		},
		{
			headerName: 'Adjustment Date', field: 'stockAdjustmentDate', headerClass: 'bg-[#f0f0f0]',
			cellRenderer: (data: any) => data.value ? showDate(data.value) : '--'
		},
		{ headerName: 'Adjusted By', field: 'addedByName', headerClass: 'bg-[#f0f0f0]', },
		{ headerName: 'Reason for adjustment', field: 'stockAdjustmentNote', headerClass: 'bg-[#f0f0f0]' },
		{ headerName: 'Facility', field: 'facilityName', headerClass: 'bg-[#f0f0f0]' },
		{
			headerName: 'Sub Facility', field: 'subFacilityName', headerClass: 'bg-[#f0f0f0]', flex: 1,
			cellRenderer: (data: any) => data.value ? data.value : '--'
		},
	];

	return (

		<div>

			<div className="display-none">
				<div className='flex items-center justify-between pl-5 pr-3 border-b border-gray-200 h-[3.75rem] '>
					<div className='flex items-center gap-3'>
						<h1 className='text-[0.9rem] leading-[1]'>Stock Adjustment History</h1>
						<Pagination
							perPage={PAGE_SIZE}
							totalRecords={totalRecords}
							onPageChange={setCurrentPage}
							currentPage={currentPage}
						/>
					</div>

					<div className='flex items-center gap-3'>
						<Search onSearch={setSearchParam} />
						<Button theme='light' disabled>Export</Button>
						<Drawer _ref={stockRef} onClose={() => {
							addNewAdjustmentRef?.current?.reset()
						}} outsideClose={false}>
							<Drawer.Button>
								<Button>New Adjustment</Button>
							</Drawer.Button>
							<Drawer.Content title='New Stock Adjustment' className='!w-[45rem]'>
								<CreateStockAdjustment _ref={addNewAdjustmentRef} editID={null} onCreate={() => {
									stockRef.current.close();
									getSpearPartsList();
								}} onCancel={() => {
									stockRef.current.close();
								}} />
							</Drawer.Content>
						</Drawer>
					</div>

				</div>
				<div>
					<div className='bg-[#FAFAFA]'>

						<div className="ag-theme-alpine h-1/2">
							<AgGridReact
								columnDefs={columnDefs} // Pass columnDefs
								rowData={rowData} // Pass rowData
								pagination={false}
								rowSelection="multiple"
								onGridReady={onGridReady}
								domLayout="autoHeight"
								onRowClicked={onRowClicked}
							/>
						</div>
					</div>
				</div>

			</div>
		</div>
	);
};

export default StockAdjustmentHistory;